import { Accessor } from "solid-js";
import { Optional } from "~/types";
import { toIndianNumber } from "~/utils/number";
import { PhosphorIcon } from "~/widgets/icons";
import { Spacer } from "~/widgets/spacer";
import { coinIcon } from "~/assets/assets";
import { useDenominationGridContext } from "../context/denomination_grid_context";

type InsufficientCoinsProps = {
  coinsBalance: number;
  requiredBalance: Accessor<Optional<number>>;
};

export function InsufficientCoins(props: InsufficientCoinsProps) {
  const { enoughCoinsAvailable, internalState } = useDenominationGridContext();

  const {
    selectedAmount,
    isSimulating,
    dryRunErrorMessage: errorMessage,
  } = internalState;
  return (
    <div
      class="flex flex-row rounded-xl border border-errorDark bg-gradient-to-r from-[#F8E6E3] px-3 py-2 transition-opacity"
      style={{
        background:
          "linear-gradient(90deg, rgba(187, 45, 19, 0.12) 2.8%, rgba(187, 45, 19, 0.00) 82.89%)",
      }}
      classList={{
        "opacity-40":
          isSimulating() ||
          selectedAmount() == null ||
          (errorMessage() != null && !enoughCoinsAvailable()),
      }}
    >
      <PhosphorIcon
        name="warning-circle"
        fontSize={24}
        class=" content-center text-errorDark"
      />
      <Spacer width={8} />
      <div class="flex flex-col">
        <span class="text-subtitleSmall text-errorDark">
          {toIndianNumber(props.requiredBalance() ?? 0)} rewards needed to get
          this card
        </span>
        <Spacer height={2} />
        <div class="flex flex-row text-small leading-4 dark:text-baseSecondaryMedium ">
          {`You have:`}
          <Spacer width={2} />
          <img src={coinIcon} class="h-4 w-4"></img>
          <Spacer width={2} />
          {toIndianNumber(props.coinsBalance)}
        </div>
      </div>
    </div>
  );
}
